import { Button, IconButton, ListSubheader, Menu, MenuItem, Select, TextField, Tooltip, hexToRgb } from "@mui/material";
import { useEffect, useState } from "react";

import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import CancelIcon from "@mui/icons-material/Cancel";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import { req } from "./ServerUtils";
import MySketchPicker from "./MySketchPicker";
import PaletteDisplay, { Palette } from "./PaletteDisplay";
import { PALETTES } from "./Palettes";
import { useUser } from './UserProvider';

  
export function BrandPanel({noSetup, closeDialog}) {
  const [brand, setBrand] = useState(null);
  const {userInfo} = useUser();
  const [setupBrandKit, setSetupBrandKit] = useState(false);

  useEffect(() => {
    if (!userInfo) return;
    setBrand(userInfo.brands[0] || {colors:[]});
  }, [userInfo]);

  useEffect(() => {
    setSetupBrandKit(!noSetup && brand && brand.colors.length == 0);
  }, [brand]);

  function updateBrandServer(newBrand) {
    setBrand(newBrand);
    req("/brands", "PUT", JSON.stringify(newBrand)).then((res) => {
      setBrand(res.brand);
    });
  }

  if (setupBrandKit) {
    return (
      <div>
        <h2>Welcome to MakeMyBrand!</h2>

        <Button
          variant="contained"
          fullWidth
          size="large"
          style={{
            textTransform: "none",
            background: "purple",
            color: "white",
          }}
          onClick={() => {
            setSetupBrandKit(false);
          }}
        >
          Setup Brand Kit
        </Button>
      </div>
    );
  }

  const props = {
    setBrand,
    updateBrandServer,
    setSetupBrandKit,
    closeDialog,
  };

  return (
    <div
      style={{
        
      }}
    >
      <BrandColors {...props} />
    </div>
  );
}


export function toRgb(c) {
  return `rgba(${c[0]}, ${c[1]}, ${c[2]}, ${c[3]})`;
}

function BrandColors({ updateBrandServer, setBrand, closeDialog }) {
  const [selectedChip, setSelectedChip] = useState(0);
  const [selectedPaletteIndex, setSelectedPaletteIndex] = useState(-1);
  const [brandColors, setBrandColors] = useState([]);
  const {userInfo, setUserInfo} = useUser();

  useEffect(() => {
    const brand = userInfo.brands && userInfo.brands.length > 0 ? userInfo.brands[0] : null;
    if (!brand || !brand.colors || brand.colors.length === 0) return;
    
    const clrs = brand.colors[0].colors.map((c) => toRgb(c));
    setBrandColors(clrs);
  }, [userInfo]);

  return (
    <div> 
        <div style={{
            textAlign: "center",
            
            padding: "0.6rem 0 1rem 0",
            fontSize: "1.3rem",
            borderBottom: "1px solid #ccc",
        }}>
            <div>Select Your Brand Colors</div>
        </div> 
      <div>
        
        {brandColors && (
          <div style={{
            display: "flex",
            justifyContent: "center",
            margin: "1rem 0",
            alignItems: "center",
            flexDirection: "row",
            gap: 10
          }}>
            <div>Current Brand Colors:</div>
            <Palette palette={brandColors} />
          </div>
        )}
      </div>    
      <div>
        {<PaletteDisplay
            selectedPaletteIndex={selectedPaletteIndex} setSelectedPaletteIndex={setSelectedPaletteIndex} 
            selectedChip={selectedChip} setSelectedChip={setSelectedChip} />
        }
      </div>

    <div style={{
        fontSize: "0.8rem",
        color: "#888",
        marginTop: 10,
        textAlign: "center"
    }}>You can change your brand colors whenever you want.</div>
    
        {<Button fullWidth variant="contained" 
        style={{
            marginTop: 10
        }}
        onClick={() => {
            const brand = userInfo.brands[0] || {colors:[]};
            brand.colors = [{ colors: PALETTES[selectedChip].palettes[selectedPaletteIndex].map((c) => hexToRgbArray(c)) }];
            req("/brands", "PUT", JSON.stringify(brand)).then((res) => {
                setBrand(res.brand);
                console.log("got from server: ", res.brand)
                setUserInfo((prev) => {
                    return {
                        ...prev,
                        brands: [res.brand],
                    };
                });
                closeDialog();
                
            });
        }}>Set Brand Colors</Button>}
    </div>
  );
}

function hexToRgbArray(hexStr) {
  const hex = hexToRgb(hexStr);
  return [
    ...hex
      .replace("rgb(", "")
      .replace(")", "")
      .split(",")
      .map((c) => parseInt(c)),
    1,
  ];
}

